import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const DocumentSearchAction = createAsyncThunk("documentSearch",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChatDocSearch, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const DocumentSearchSlice = createSlice({
    name: "documentSearch",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        DocumentSearchReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [DocumentSearchAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [DocumentSearchAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [DocumentSearchAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { DocumentSearchReset } = DocumentSearchSlice.actions
export default DocumentSearchSlice.reducer